// Admin-gated on-device debug console using eruda.
// Provides real-time console output inside the Telegram Mini App WebView —
// useful for diagnosing the production SSE streaming pipeline without external devtools.

/** Module-level guard: eruda is only initialised once per page load. */
let initialised = false;

/**
 * Dynamically load and init eruda.
 * Must ONLY be called from code that has already verified `isAdmin === true`.
 * Regular users never trigger this; it is never auto-called on startup.
 */
export async function initEruda(): Promise<void> {
  if (initialised) return;
  initialised = true;
  const eruda = await import('eruda');
  eruda.default.init();
}
